/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication/contexts'
import { useCartContext } from '@mercadoni/sinister/dist/cjs/cart/contexts'
import { FC, useEffect, useState } from 'react'

interface CartLogicProps {
  Wrapper: FC<any>
  className?: string
}

const CartLogic: FC<CartLogicProps> = ({ Wrapper, className }) => {
  const { isLogged } = UseLoggedContext()
  const [cartProductsCount, setCartProductsCount] = useState<number>()
  const { products } = useCartContext()
  const {
    copies: { header: copy },
  } = useHeaderContext()

  useEffect(() => {
    const count = Object.keys(products)?.length || 0
    setCartProductsCount(count)
  }, [products, isLogged])

  return (
    <Wrapper
      className={className}
      cartProductsCount={cartProductsCount}
      copy={copy}
    />
  )
}

export default CartLogic
